var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tab',_vm._b({on:{"click":_vm.clicked,"change":_vm.changed}},'v-tab',_vm.$props,false),[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }